export const countriesCodes = [
  'DZ',
  'AO',
  'AR',
  'AM',
  'AU',
  'AT',
  'AZ',
  'BD',
  'BY',
  'BE',
  'BA',
  'BW',
  'BR',
  'BG',
  'BF',
  'KH',
  'CM',
  'CA',
  'TD',
  'CL',
  'CO',
  'CR',
  'HR',
  'CY',
  'CZ',
  'DK',
  'DO',
  'EC',
  'EG',
  'SV',
  'EE',
  'FI',
  'FR',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GR',
  'GT',
  'HK',
  'HU',
  'IS',
  'IN',
  'ID',
  'IE',
  'IL',
  'IT',
  'CI',
  'JP',
  'JO',
  'KZ',
  'KE',
  'XK',
  'KG',
  'LA',
  'LV',
  'LB',
  'LT',
  'LU',
  'MG',
  'MW',
  'MY',
  'MT',
  'MR',
  'MU',
  'MX',
  'MD',
  'MA',
  'MZ',
  'NA',
  'NP',
  'NL',
  'NG',
  'MK',
  'NO',
  'PK',
  'PE',
  'PH',
  'PL',
  'PT',
  'QA',
  'RO',
  'RW',
  'SA',
  'SN',
  'RS',
  'SG',
  'SK',
  'SI',
  'ZA',
  'KR',
  'ES',
  'LK',
  'SE',
  'CH',
  'TW',
  'TZ',
  'TH',
  'TG',
  'TN',
  'TR',
  'UA',
  'AE',
  'GB',
  'US',
  'UY',
  'UZ',
  'VN',
  'ZM',
  'ZW',
];
